import { SolDialogState } from '../abstract-dialog-component.directive';
import { SolDialog, SolDialogType } from '../../../models/core/sol-dialog';
import { SolText } from '../../../models/core/sol-text';
import { ObjectTools } from '../../../tools/object-tools';

export class SolInfoDialogState implements SolDialogState {
  private constructor(
    public readonly dialog: SolDialog,
    public readonly text: SolText,
  ) {}

  public static of(): SolInfoDialogState {
    return new SolInfoDialogState(SolDialog.ofInfo(SolText.empty()), SolText.empty());
  }

  public withDialog(dialog: SolDialog): this {
    return ObjectTools.copy<SolInfoDialogState>(this, { dialog }) as this;
  }

  public withText(text: SolText): SolInfoDialogState {
    if (ObjectTools.equals(this.text, text)) {
      return this;
    }
    return ObjectTools.copy<SolInfoDialogState>(this, { text });
  }

  public withConfig(title: SolText, text: SolText, type?: SolDialogType): SolInfoDialogState {
    let dialog = SolDialog.ofInfo(title);
    if (type) {
      dialog = dialog.withType(type);
    }
    return ObjectTools.copy<SolInfoDialogState>(this, { dialog, text });
  }
}
